<template>
    <v-modal :active="active">
        <div v-padding="2">
            <v-row>
                <v-col></v-col>
                <v-col xs="8">
                    <div v-margin.top="1" v-text-align.center>
                        <v-text type="subheadling" bold style="font-size: 24px;">
                            {{ theme }}
                        </v-text>
                    </div>
                    <div v-text-align.center v-margin.top="2">
                        <div style="display: inline-block; margin-left: -15px;">
                            <star-rating v-model="rating" :starSize="46" :maxStars ="10"/>
                        </div>
                    </div>
                    <div v-text-align.center v-margin.top="2">
                        <v-button primary @click="handleSubmit">Проголосовать</v-button>
                    </div>
                </v-col>
                <v-col v-text-align.right>
                    <v-icon-button @click="close">
                        clear
                    </v-icon-button>
                </v-col>
            </v-row>
        </div>
    </v-modal>
</template>

<script>
import StarRating from '../../../baseComponents/components/StarRating/StarRating.vue';

export default {
    name: 'modal-survey',
    props: {
        active: Boolean,
        theme: String,
        onCreateResult: Function,
        close: Function
    },
    components: {
        StarRating,
    },
    data() {
        return {
            rating: 10,
        };
    },
    methods: {
        handleSubmit() {
            this.onCreateResult(this.rating);
        },
    },
};
</script>


// WEBPACK FOOTER //
// ModalSurvey.vue?fce3f8aa